import Layout from '@/layouts/index.vue';

export default [
  {
    path: '/user',
    name: 'user',
    component: Layout,
    redirect: '/user/base',
    meta: {
      title: '个人中心',
      icon: 'user-circle',
      hidden: true,
    },
    children: [
      {
        path: 'base',
        name: 'UserBase',
        component: () => import('@/pages/user/base/index.vue'),
        meta: {
          title: '个人中心',
        },
      },
    ],
  },
];
